import { defineMessage } from "react-intl";

export type CallEndError = {
    cause: string;
    message?: string;
};

export const getCallEndNotification = (error?: CallEndError) => {
    if (!error) return undefined;

    const message = error.message?.trim();
    if (message)
        return {
            message: defineMessage({
                id: "meetingPage.room.callEndedError",
                defaultMessage: "The conference ended because of an error: {reason}",
            }),
            vars: { reason: message },
        };

    return {
        message: defineMessage({
            id: "meetingPage.room.callEndedUnexpectedly",
            defaultMessage: "The conference ended because of an error.",
        }),
        vars: {},
    };
};
